import { render, staticRenderFns } from "./FullModal.vue?vue&type=template&id=4b113bba&scoped=true"
import script from "./FullModal.vue?vue&type=script&lang=js"
export * from "./FullModal.vue?vue&type=script&lang=js"
import style0 from "./FullModal.vue?vue&type=style&index=0&id=4b113bba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b113bba",
  null
  
)

export default component.exports